"use strict";
exports.__esModule = true;
exports.getCollectionMode = exports.setCollectionMode = exports.getAppEnvironment = exports.setAppEnvironment = void 0;
var environment;
function setAppEnvironment(appEnvironment) {
    environment = appEnvironment;
}
exports.setAppEnvironment = setAppEnvironment;
function getAppEnvironment() {
    if (!environment) {
        throw new Error("appEnvironment not set: was Blizzard initialized?");
    }
    return environment;
}
exports.getAppEnvironment = getAppEnvironment;
var collectionMode;
function setCollectionMode(mode) {
    collectionMode = mode;
}
exports.setCollectionMode = setCollectionMode;
function getCollectionMode() {
    if (!collectionMode) {
        throw new Error("collectionMode not set: was Blizzard initialized?");
    }
    return collectionMode;
}
exports.getCollectionMode = getCollectionMode;
//# sourceMappingURL=environment.js.map